import slugify from 'slugify';
import { createUID } from '@/assets/create-unique-id.js';
export default {
  getCurrentlySelectedLevel(state) {
    return state.currentlySelectedLevel[state.showLevels][state.currentRouteName];
  },
  getSoundsequenceList(state) {
    if (state.currentRouteName === 'createIdentifyChordsExercise' || state.currentRouteName === 'createIdentifyChordInversionsExercise' || state.currentRouteName === 'editIdentifyChordsExercise' || state.currentRouteName === 'editIdentifyChordInversionsExercise') {
      return state.soundSequenceNames['chords'];
    }
    if (state.currentRouteName === 'createIdentifyIntervalsExercise' || state.currentRouteName === 'createCompareIntervalSizesExercise' || state.currentRouteName === 'editCompareIntervalSizesExercise' || state.currentRouteName === 'editIdentifyIntervalsExercise') {
      return state.soundSequenceNames['intervals'];
    }
    if (state.currentRouteName === 'createIdentifyScalesExercise' || state.currentRouteName === 'editIdentifyScalesExercise') {
      return state.soundSequenceNames['scales'];
    }
  },
  getShowLevels(state) {
    return state.showLevels;
  },
  getUserExerciseIdAndDisciplineToAddTo(state) {   
    
    if (!state.currentUserDiscipline) {
      return;
    } else {
        let disciplineToAddTo = state.currentUserDiscipline; // "userLevelsIdentifyChords"

      return {
        disciplineToAddTo: disciplineToAddTo
        }
      }
  },
  getExerciseInfo(state) {
    return state.currentlySelectedLevel[state.showLevels][state.currentRouteName];
  },
  getExerciseFromId: state => id => {
    return state[state.currentUserDiscipline][id];
  },
  getExerciseList(state) {
     // get the standard and user levels with name as route
    if (state.showLevels === 'standard') {
      return state[`standardLevels${state.currentRouteName}`];
    } else if (state.showLevels === 'user') {
      if (state.currentRouteName === 'CompareIntervalSizes' || state.currentRouteName === 'createCompareIntervalSizesExercise') { return state['userLevelsCompareIntervalSizes']; }
      else if (state.currentRouteName === 'IdentifyIntervals' || state.currentRouteName === 'createIdentifyIntervalsExercise') { return state['userLevelsIdentifyIntervals']; }
      else if (state.currentRouteName === 'IdentifyChords' || state.currentRouteName === 'createIdentifyChordsExercise') { return state['userLevelsIdentifyChords']; }
      else if (state.currentRouteName === 'IdentifyChordInversions' || state.currentRouteName === 'createIdentifyChordInversionsExercise') { return state['userLevelsIdentifyChordInversions']; }
      else if (state.currentRouteName === 'IdentifyScales' || state.currentRouteName === 'createIdentifyScalesExercise') { return state['userLevelsIdentifyScales']; }
      else {return state[`userLevels${state.currentRouteName}`]; }
    }
  },
  currentUserDisciplineIsScales(state) {
    if (state.currentUserDiscipline === 'userLevelsIdentifyScales') {
      return true;
    } else {
      return false;
    }
  },
  getExerciseBeingEdited(state) {
    return state.exerciseBeingEdited;
  },
  getCorrectNotes(state) {
    return state.correctNotes;
  },
  getIncorrectNotes(state) {
    return state.incorrectNotes;
  },
  getCorrectNotesPositionX(state) {
    return state.dotsPositionCorrect;
  },
  getIncorrectNotesPositionX(state) {
    return state.dotsPositionIncorrect;
  },
  getNoteRange(state) {
    return state.noteRange;
  },
  getprogressLamps(state) {
    return state.progressLamps;
  },
  getCurrentExercise(state) {
    return state.exercisePlaying;
  },
  getDisciplinePlaying(state) {
    return state.disciplinePlaying;
  },
  getCurrentExerciseIndex(state) {
    return state.currentExerciseIndex;
  },
  getQuestionNumberInCurrentExercise(state) {
    return state.questionNumberInCurrentExercise;
  },
  getcurrentExerciseRandomQuestions(state) {
    return state.currentExerciseRandomQuestions;
  },
  getCorrectAnswer(state) {
    return state.correctAnswer;
  },
  getUserAnswer(state) {
    return state.userAnswer;
  },
  getSoundsequenceDataForCorrectAnswer(state) {
    return state.soundSequenceDataForCorrectAnswer;
  },
  getQuestionStartNote(state) {
    return state.questionStartNote;
  },
  getDisciplineModeTonal(state) {
    return state.disciplineModeTonal;
  },
  getWaitingForUserAnswer(state) {
    return state.waitingForUserAnswer;
  },
  getShowEvaluationPopup(state) {
    return state.showEvaluationPopup;
  },
  getCurrentExerciseScore(state) {
    return state.currentExerciseScore;
  },
  getSlugifiedVersionOfNextExercise: (state, getters) => id => {
    let exerciseTitle = state[getters.getDisciplinePlaying][id]['title'];
    let exerciseSlug = slugify(exerciseTitle, {
      replacement: '-', 
      remove: /[*/+~.()'",!:@]/g,
      lower: true
    }).replace(/#/g, '-sharp-');
    
    return exerciseSlug;
  },
  getNumberOfExercisesInCurrentDiscipline(state, getters) {
    if (getters.getDisciplinePlaying) {
      let discipline = getters.getDisciplinePlaying;
      return state[discipline].length;
    }
  },
  getCorrectAnswersInCurrentExercise(state) {
    return state.correctAnswersInCurrentExercise;
  },
  getNextQuestionText(state) {
    return state.nextQuestionText;
  },
  getCorrectOrWrongAnswer(state) {
    return state.correctOrWrongAnswer;
  },
  getCompareIntervalSizesCorrectData(state) {
    return state.compareIntervalSizesCorrectData;
  },
  getCompareIntervalSizesIncorrectData(state) {
    return state.compareIntervalSizesIncorrectData;
  },
  getAnswersForPossibleIdentifyChordInversions(state) {
    return state.answersForPossibleIdentifyChordInversions;
  },
  getAllAnswerPossibilitiesForChordInversions(state) {
    return state.allAnswerPossibilitiesForChordInversions;
  },
  getStartnoteBeforeInvert(state) {
    return state.startnoteBeforeInvert;
  },
  getSoundSequenceForIntervalAandIntervalB(state) {
    return state.soundSequenceForIntervalAandIntervalB;
  },
  getIsExerciseBeingEdited(state) {
    return state.isExerciseBeingEdited;
  },
  getStandardScores(state) {
    let currentUserDiscipline = state.currentUserDiscipline;
    
    switch(currentUserDiscipline) {
      case 'userLevelsIdentifyChords':
        return state.standardExerciseScores.identifyChordsScores;
        //break;
      case 'userLevelsIdentifyIntervals':
        return state.standardExerciseScores.identifyIntervalsScores;
        //break;
      case 'userLevelsCompareIntervalSizes':
        return state.standardExerciseScores.compareIntervalSizesScores;
        //break;
      case 'userLevelsIdentifyChordInversions':
        return state.standardExerciseScores.identifyChordInversionsScores;
        //break;
      case 'userLevelsIdentifyScales':
        return state.standardExerciseScores.identifyScalesScores;
        //break;
    }
  },
  getNumberOfExercisesInCurrentUserDiscipline(state) {
    if (state.currentUserDiscipline) {
      let currentUserDiscipline = state.currentUserDiscipline;
      return state[currentUserDiscipline].length;
    }
    
  },
  getGameSettings(state) {
    return state.gameSettings;
  },
  getIsGameRunning(state) {
    return state.isGameRunning;
  },
  getShowExerciseDescription(state) {
    return state.showExerciseDescription;
  },
  getShowExerciseList(state) {
    return state.showExerciseList;
  },
  getShowCreateExerciseSoundSequenceList(state) {
    return state.showCreateExerciseSoundSequenceList;
  },
  getShowCreateExerciseSettings(state) {
    return state.showCreateExerciseSettings;
  },
  getShowUserExerciseDescription(state) {
    return state.showUserExerciseDescription;
  },
  getShowUserExerciseList(state) {
    return state.showUserExerciseList;
  },
  getAllStandardExerciseScores(state) {
    return state.standardExerciseScores;
  },
  getCompareIntervalSizesExercises(state) {
    return state.standardLevelsCompareIntervalSizes;
  },
  getIdentifyIntervalsExercises(state) {
    return state.standardLevelsIdentifyIntervals;
  },
  getIdentifyChordsExercises(state) {
    return state.standardLevelsIdentifyChords;
  },
  getIdentifyChordInversionsExercises(state) {
    return state.standardLevelsIdentifyChordInversions;
  },
  getIdentifyScalesExercises(state) {
    return state.standardLevelsIdentifyScales;
  },
  getUser(state) {
    return state.user;
  },
  getShowSignUpDialog(state) {
    return state.showSignUpDialog;
  },
  getShowLogInDialog(state) {
    return state.showLogInDialog;
  },
  getShowUserMenu(state) {
    return state.showUserMenu;
  },
  getShowUserMenuDialogMobile(state) {
    return state.showUserMenuDialogMobile;
  },
  getShowLoginSignupBottomSheet(state) {
    return state.showLoginSignupBottomSheet;
  },
  getShowLoginToAccessDialog(state) {
    return state.showLoginToAccessDialog;
  },
  getUserObject(state) {
    return state.userObject;
  },
  getShowDataCopiedToDatabaseDialog(state) {
    return state.showDataCopiedToDatabaseDialog;
  },
  getNavigatedFromStartButton(state) {
    return state.navigatedFromStartButton;
  },
  getCurrentRoutePath(state) {
    return state.currentRoutePath;
  }

}